export default "__VITE_ASSET__fde1f10b__"